import { z } from "zod";

import { subscriptionSchema } from "./subscription-schema";

export const tenantSubscriptionSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	customerId: z.string(),
	subscriptions: z.array(subscriptionSchema),
});

export type TenantSubscription = z.infer<typeof tenantSubscriptionSchema>;
